import { useEffect, useState } from "react";
import { isHotkeyPressed } from "react-hotkeys-hook";

import Emojify from "~/components/shared/Emojify";
import { CommandItem } from "~/components/shared/Command";
import { Step, labelForStep } from "~/lib/pipeline";

/** @deprecated Use `~/components/build/Show/routes/steps/list/-components/StepSearch/StepSearchItem` instead. */
export function StepSearchItem({
  step,
  onSelect,
}: {
  step: Step;
  onSelect: (currentValue: string) => void;
}) {
  const [shiftPressed, setShiftPressed] = useState(false);

  useEffect(() => {
    function callback() {
      setShiftPressed(isHotkeyPressed("shift"));
    }

    document.addEventListener("keydown", callback);
    document.addEventListener("keyup", callback);

    return () => {
      document.removeEventListener("keydown", callback);
      document.removeEventListener("keyup", callback);
    };
  }, []);

  return (
    <CommandItem className="group" key={step.uuid} value={step.uuid} onSelect={onSelect}>
      <Emojify text={labelForStep(step)} className="truncate" />

      <span className="ml-auto whitespace-nowrap text-xs group-data-[selected=false]:hidden">
        {shiftPressed ? "Focus step" : "Go to step"}
      </span>
    </CommandItem>
  );
}
